import { render, staticRenderFns } from "./nearbyHotDetail.vue?vue&type=template&id=4b8ebef2&scoped=true&"
import script from "./nearbyHotDetail.vue?vue&type=script&lang=js&"
export * from "./nearbyHotDetail.vue?vue&type=script&lang=js&"
import style0 from "./nearbyHotDetail.vue?vue&type=style&index=0&id=4b8ebef2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ebef2",
  null
  
)

export default component.exports